import React, { Component } from 'react';
import { typeToHumanReadable, receiverFromType } from '../../../../selectors/admin/models/event.emails';
import RichTextEditor from '../RichTextEditor';
import { RT_TYPE_EMAIL } from '../../../../constants/admin/settings';
import CKPButton from '../../../forms/Button';
import Input from '../../../forms/Input';
import SelectField from '../../../forms/SelectField';

class EmailEditor extends Component {
    constructor(props) {
        super(props);
        this.richTextEditor = React.createRef();
    }
    componentDidMount() {
        this.richTextEditor.current.start();
    }
    _saveEmail = () => this.props.onSave({ ...this.props.email, content: this.richTextEditor.current.getContent() });
    _onChangeSender = x => {
        const value = JSON.parse(x);
        this.props.onInput(value.name, 'senderName');
        this.props.onInput(value.email, 'sender');
    };
    render() {
        const { email, onCancel, onInput, senderOptions } = this.props;
        return (
            <div className="ckp-email-editor">
                <header className="ckp-email-editor-head">
                    <h1 className="ckp-ts-h1">
                        {typeToHumanReadable(email.type)} - {receiverFromType(email.type)}
                    </h1>
                    <div className="ckp-email-editor-buttons">
                        <a onClick={onCancel} className="ckp-buttons-text is-warning">
                            Cancel
                        </a>
                        <CKPButton label="Save email" onClick={this._saveEmail} />
                    </div>
                </header>
                <div className="ckp-email-editor-form">
                    <div className="ckp-admin-grid-row">
                        <div className="ckp-admin-grid-column">
                            <SelectField
                                label="Select verified sender"
                                name="sender"
                                onChange={this._onChangeSender}
                                items={senderOptions}
                            />
                        </div>
                        <div className="ckp-admin-grid-column">
                            <Input
                                onChange={onInput}
                                className="ckp-email-editor-sender"
                                label="Sender email address"
                                value={email.sender || ''}
                                name="sender"
                                disabled={true}
                            />
                        </div>
                        <div className="ckp-admin-grid-column">
                            <Input
                                onChange={onInput}
                                className="ckp-email-editor-sender-name"
                                label="Sender name"
                                value={email.senderName || ''}
                                name="senderName"
                            />
                        </div>
                    </div>
                    <div className="ckp-admin-grid-row">
                        <Input
                            onChange={onInput}
                            className="ckp-email-editor-subject"
                            label="Subject"
                            value={email.subject}
                            name="subject"
                        />
                    </div>
                </div>
                <RichTextEditor
                    subType={email.type}
                    type={RT_TYPE_EMAIL}
                    email={true}
                    autoSave={false}
                    ref={this.richTextEditor}
                    data={this.props.email.content}
                    className="ckp-email-editor-body"
                />
            </div>
        );
    }
}

export default EmailEditor;
